import { ApolloError } from '@apollo/client'
import { useCallback } from 'react'
import { useToast } from './useToast'

export const useApolloErrorToast = () => {
  const toast = useToast()
  const showToastError = useCallback(
    (e: ApolloError) => {
      let title = '問題が発生しました。時間を置いて再度お試しください。'

      if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        const firstError = e.graphQLErrors[0]
        // detailed_code が入っている場合は、バックエンド側でエラーハンドリングされた想定されたエラーのため、メッセージを表示する
        if (firstError.extensions?.['detailed_code']) {
          title = firstError.message
        }
      }

      toast({
        title,
        status: 'error',
      })
    },
    [toast],
  )

  return showToastError
}
